// @flow
export const SELECT_ORIGINAL = "changeFlights/SELECT_ORIGINAL"
export const CLEAR_ORIGINAL = "changeFlights/CLEAR_ORIGINAL"
export const SELECT_ALTERNATIVE = "changeFlights/SELECT_ALTERNATIVE"
export const CLEAR_ALTERNATIVE = "changeFlights/CLEAR_ALTERNATIVE"
export const INITIATOR_API = "changeFlights/INITIATOR_API"
export const CLEAR_STATE = "changeFlights/CLEAR_STATE"
export const SET_FORM_OPEN = "changeFlights/SET_FORM_OPEN"
export const SET_CONTACT_FORM_OPEN = "changeFlights/SET_CONTACT_FORM_OPEN"
export const CHECK_FLIGHT = "changeFlights/CHECK_FLIGHT"
export const CHECK_FLIGHT_REQUEST = "changeFlights/CHECK_FLIGHT_REQUEST"
export const CHECK_FLIGHT_SUCCESS = "changeFlights/CHECK_FLIGHT_SUCCESS"
export const CHECK_FLIGHT_FAILURE = "changeFlights/CHECK_FLIGHT_FAILURE"
export const CONFIRM = "changeFlights/CONFIRM"
export const CONFIRM_REQUEST = "changeFlights/CONFIRM_REQUEST"
export const CONFIRM_SUCCESS = "changeFlights/CONFIRM_SUCCESS"
export const CONFIRM_FAILURE = "changeFlights/CONFIRM_FAILURE"
export const FORM_ACTIVE_MODE = "changeFlights/FORM_ACTIVE_MODE"
export const FORM_ACTIVE_FIELD = "changeFlights/FORM_ACTIVE_FIELD"
export const FORM_NEXT_FIELD = "changeFlights/FORM_NEXT_FIELD"
export const FORM_CHANGE_FORM = "changeFlights/FORM_CHANGE_FORM"
export const FORM_CHANGE_VALUE = "changeFlights/FORM_CHANGE_VALUE"
export const FORM_SUBMIT = "changeFlights/FORM_SUBMIT"
export const FORM_SUBMIT_REQUEST = "changeFlights/FORM_SUBMIT_REQUEST"
export const FORM_SUBMIT_SUCCESS = "changeFlights/FORM_SUBMIT_SUCCESS"
export const FORM_SUBMIT_FAILURE = "changeFlights/FORM_SUBMIT_FAILURE"
